export default __webpack_public_path__ + "static/media/OldTownSquare18_sm.d40608f1.jpg";